/* Classic Replacements - Condition info mark (Claude, Nov 1 2026).
   Adds a small (i) next to "Condition:" in the product description and opens a
   short summary of the Quality Guarantee (/pages/quality-guarantee). */
(function () {
  if (window.__crCondInfo || !/\/products\//.test(location.pathname)) return;
  window.__crCondInfo = true;

  var CSS = '' +
    '.cr-ci-wrap{display:inline-block;vertical-align:middle;margin-left:.35em;line-height:1}' +
    '.cr-ci-btn{all:unset;box-sizing:border-box;display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:50%;' +
      'border:1.5px solid rgb(9,96,154);color:rgb(9,96,154);font:italic 600 11px/1 Georgia,"Times New Roman",serif;cursor:pointer;' +
      'transition:background .15s,color .15s,transform .15s;position:relative;top:-1px}' +
    '.cr-ci-btn:hover,.cr-ci-btn[aria-expanded="true"]{background:rgb(9,96,154);color:#fff}' +
    '.cr-ci-btn:focus-visible{outline:2px solid rgba(9,96,154,.4);outline-offset:2px}' +
    '.cr-ci-pop{position:absolute;z-index:1000;left:0;top:0;width:320px;max-width:calc(100vw - 32px);' +
      'background:#fff;border-radius:14px;box-shadow:0 12px 40px rgba(46,42,57,.18),0 2px 6px rgba(46,42,57,.08);' +
      'border:1px solid rgba(46,42,57,.08);color:rgb(46,42,57);font-family:Jost,sans-serif;font-size:14px;line-height:1.45;' +
      'text-align:left;letter-spacing:.01em;opacity:0;visibility:hidden;transform:translateY(6px);' +
      'transition:opacity .18s ease,transform .18s ease,visibility .18s;overflow:hidden}' +
    '.cr-ci-pop.cr-open{opacity:1;visibility:visible;transform:none}' +
    '.cr-ci-pop:before{content:"";position:absolute;top:-7px;left:var(--cr-arrow,50%);width:12px;height:12px;background:rgb(9,96,154);' +
      'transform:translateX(-50%) rotate(45deg);border-radius:2px}' +
    '.cr-ci-head{position:relative;display:flex;align-items:center;gap:10px;padding:14px 18px;background:rgb(9,96,154);color:#fff}' +
    '.cr-ci-head svg{flex:0 0 22px}' +
    '.cr-ci-title{font-size:15px;font-weight:500;letter-spacing:.03em;margin:0;color:#fff}' +
    '.cr-ci-sub{font-size:12px;opacity:.85;margin:1px 0 0;color:#fff}' +
    '.cr-ci-x{all:unset;position:absolute;right:10px;top:8px;width:26px;height:26px;border-radius:50%;display:flex;align-items:center;' +
      'justify-content:center;cursor:pointer;color:#fff;opacity:.8;font-size:18px;line-height:1}' +
    '.cr-ci-x:hover{opacity:1;background:rgba(255,255,255,.15)}' +
    '.cr-ci-list{list-style:none;margin:0;padding:14px 18px 6px}' +
    '.cr-ci-list li{display:flex;gap:10px;align-items:flex-start;margin:0 0 9px;padding:0}' +
    '.cr-ci-list li:before{content:"";flex:0 0 18px;height:18px;margin-top:1px;border-radius:50%;background:rgba(9,96,154,.1) ' +
      'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M6 12.5l4 4 8-9%27 fill=%27none%27 stroke=%27%2309609a%27 stroke-width=%272.6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E") center/12px no-repeat}' +
    '.cr-ci-note{margin:4px 18px 0;padding:10px 12px;background:#f6f5f2;border-radius:8px;font-size:12.5px;color:rgba(46,42,57,.8)}' +
    '.cr-ci-foot{padding:12px 18px 16px}' +
    '.cr-ci-foot a{color:rgb(9,96,154);font-weight:500;text-decoration:none;font-size:13px;letter-spacing:.02em}' +
    '.cr-ci-foot a:hover{text-decoration:underline}' +
    '@media (max-width:600px){.cr-ci-pop{position:fixed;left:50%;top:auto;bottom:16px;width:calc(100vw - 32px);transform:translate(-50%,16px)}' +
      '.cr-ci-pop.cr-open{transform:translate(-50%,0)}.cr-ci-pop:before{display:none}' +
      '.cr-ci-backdrop{position:fixed;inset:0;background:rgba(46,42,57,.35);z-index:999;opacity:0;visibility:hidden;transition:opacity .18s}' +
      '.cr-ci-backdrop.cr-open{opacity:1;visibility:visible}}' +
    '@media (min-width:601px){.cr-ci-backdrop{display:none}}';

  var SHIELD = '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l7.5 3v5.6c0 4.7-3.1 8.9-7.5 10.4-4.4-1.5-7.5-5.7-7.5-10.4V5.5z" fill="rgba(255,255,255,.18)" stroke="#fff" stroke-width="1.6" stroke-linejoin="round"/><path d="M8.5 12.2l2.4 2.4 4.6-5" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var BODY =
    '<div class="cr-ci-head">' + SHIELD +
      '<div><p class="cr-ci-title">Our Quality Guarantee</p><p class="cr-ci-sub">Every piece, new or pre-owned</p></div>' +
      '<button type="button" class="cr-ci-x" aria-label="Close">&times;</button></div>' +
    '<ul class="cr-ci-list">' +
      '<li>No chips, cracks, crazing or breakage</li>' +
      '<li>No heavy use, scratches or trim wear</li>' +
      '<li>First quality only &mdash; never seconds</li>' +
      '<li>30-day returns for any reason</li>' +
    '</ul>' +
    '<p class="cr-ci-note">Any minor flaw is clearly noted in the condition, and the price reflects it. Not happy with it? Return it within 30 days for a full refund.</p>' +
    '<div class="cr-ci-foot"><a href="/pages/quality-guarantee">Read our full guarantee &rarr;</a></div>';

  var pop, bd, cur = null;
  function build() {
    if (pop) return;
    bd = document.createElement('div'); bd.className = 'cr-ci-backdrop';
    pop = document.createElement('div'); pop.className = 'cr-ci-pop'; pop.id = 'cr-ci-pop';
    pop.setAttribute('role', 'dialog'); pop.setAttribute('aria-label', 'Our Quality Guarantee');
    pop.innerHTML = BODY;
    document.body.appendChild(bd); document.body.appendChild(pop);
    pop.querySelector('.cr-ci-x').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); var b = cur; close(); if (b) b.focus(); });
    pop.addEventListener('click', function (e) { e.stopPropagation(); });
    bd.addEventListener('click', function (e) { e.stopPropagation(); close(); });
  }
  function close() {
    if (!cur) return;
    pop.classList.remove('cr-open'); bd.classList.remove('cr-open');
    cur.setAttribute('aria-expanded', 'false');
    cur = null;
  }
  function place() {
    if (!cur) return;
    pop.style.left = ''; pop.style.top = ''; pop.style.setProperty('--cr-arrow', '50%');
    if (window.innerWidth <= 600) return;
    var w = pop.offsetWidth, r = cur.getBoundingClientRect();
    var cx = r.left + r.width / 2, vw = document.documentElement.clientWidth;
    var left = Math.min(Math.max(cx - w / 2, 16), vw - 16 - w);
    pop.style.left = (left + window.scrollX) + 'px';
    pop.style.top = (r.bottom + 12 + window.scrollY) + 'px';
    pop.style.setProperty('--cr-arrow', (cx - left) + 'px');
  }

  function attach(strong) {
    if (strong.getAttribute('data-cr-ci')) return;
    strong.setAttribute('data-cr-ci', '1');
    var wrap = document.createElement('span');
    wrap.className = 'cr-ci-wrap';
    wrap.innerHTML = '<button type="button" class="cr-ci-btn" aria-label="About our condition standards" aria-haspopup="dialog" aria-expanded="false" aria-controls="cr-ci-pop">i</button>';
    strong.insertAdjacentElement('afterend', wrap);
    var btn = wrap.firstChild;
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (cur === btn) { close(); return; }
      close(); build();
      cur = btn; place();
      pop.classList.add('cr-open'); bd.classList.add('cr-open');
      btn.setAttribute('aria-expanded', 'true');
    });
  }

  // Hide description lines that carry a label but no information, e.g. "Condition:" or "Size:" left empty.
  var EMPTY = /^[\s\u00a0:\-\u2013\u2014.]*(n\/?a|none|tbd|unknown)?[\s\u00a0.]*$/i;
  function hideEmpty(root) {
    var ps = root.querySelectorAll('p, li');
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i], lab = p.querySelector('strong, b');
      if (!lab || p.getAttribute('data-cr-empty-checked')) continue;
      if (!/:\s*$/.test(lab.textContent)) continue;
      var rest = p.textContent.replace(lab.textContent, '');
      // label must be the first thing in the line
      if (p.textContent.replace(/^[\s\u00a0]+/, '').indexOf(lab.textContent.replace(/^[\s\u00a0]+/, '')) !== 0) continue;
      p.setAttribute('data-cr-empty-checked', '1');
      if (EMPTY.test(rest)) p.style.display = 'none';
    }
  }

  function scan() {
    var roots = document.querySelectorAll('.product__description');
    for (var r = 0; r < roots.length; r++) hideEmpty(roots[r]);
    var nodes = document.querySelectorAll('.product__description strong, .product__description b');
    for (var i = 0; i < nodes.length; i++) {
      var p = nodes[i].closest('p, li');
      if (p && p.style.display === 'none') continue;
      if (/^\s*Condition\s*:?\s*$/i.test(nodes[i].textContent)) attach(nodes[i]);
    }
  }

  function init() {
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
    scan();
    document.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', place);
    window.addEventListener('scroll', place, { passive: true }); // the product info column is sticky
    // product pages can swap the description when a variant changes
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 150); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
